import { AirhelpLogo } from "styles/logos";

const Logo = ({ ...props }) => <AirhelpLogo data-testid="top-navbar-logo" {...props} />;

export default Logo;
